import React from 'react'
import '../App.css';

export default function Content() {
  return (
    <div className='play'>
    <div className="game-wrapper" >                  
    <div className='game-container'> 
   <a href='https://play-it-memory.netlify.app/' target="_self" rel='noreferrer'>
   <button className='game-name'>Memory</button>
  <img src={"./img/memo.png"} alt="Memory" width={250} height={250}/>
  </a>
  </div>
  <div className='game-container'> 
   <a href='https://play-it-tetris.netlify.app/' target="_self" rel='noreferrer'>
   <button className='game-name'>Tetris</button>
  <img src={"./img/tetrisbild.jpg"} alt="Tetris" width={250} height={250}/>
  </a>
  </div>
  <div className='game-container'> 
   <a href='https://play-it-quiz.netlify.app/' target="_self" rel='noreferrer'>
   <button className='game-name'>Quiz</button>
  <img src={"./img/quiz.jpg"} alt="Quiz" width={250} height={250}/>
  </a>
  </div>
  </div>
  </div>
  )
}
